import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import BeginnerSidebar from "./BeginnerSidebar";
import { getBeginnerMainExams, unwrapRows } from "../api/beginnerExamClient";
import "../styles/practice.css";
import "../styles/BeginnerExam.css";

const RULES = [
  "Read each question carefully before answering.",
  "Do not leave the examination page while the exam is in progress.",
  "Your exam duration is controlled by the server and shown in the timer.",
  "Your answers are saved to your Beginner exam attempt.",
  "Do not use unauthorized books, phones or other assistance.",
  "If camera proctoring is enabled for this exam, allow camera access and follow its instructions.",
];

export default function BeginnerExamCriteria() {
  const { examAccessId } = useParams();
  const navigate = useNavigate();
  const [exam, setExam] = useState(null);
  const [checked, setChecked] = useState(false);
  const [loading, setLoading] = useState(true);
  const [starting, setStarting] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    getBeginnerMainExams()
      .then((response) => {
        const match = unwrapRows(response).find((item) => String(item.id) === String(examAccessId));
        if (active) {
          setExam(match || null);
          if (!match) setError("This exam is not available for your account or class level.");
        }
      })
      .catch((e) => active && setError(e?.response?.data?.detail || "Unable to load exam details."))
      .finally(() => active && setLoading(false));
    return () => { active = false; };
  }, [examAccessId]);

  const start = () => {
    if (!checked || !exam) return;
    setStarting(true); setError("");
    // The attempt is created only by the Beginner backend, which checks subscription and eligibility.
    navigate(`/beginner/examination/${exam.id}`);
  };

  return <div className="oes-page-full practice-page beginner-dashboard"><div className="oes-home-shell d-flex flex-row"><BeginnerSidebar /><main className="flex-grow-1 oes-page container-fluid px-3 px-md-4 py-4">
    <header className="practice-heading"><div><span className="practice-eyebrow">BEGINNER EXAMINATION</span><h1>Exam Criteria</h1><p>Review the rules before entering your examination.</p></div></header>
    {loading ? <section className="practice-setup-card">Loading exam details…</section> : error ? <section className="practice-setup-card"><p role="alert">{error}</p><button type="button" onClick={() => navigate("/beginner/main-exam")}>Back to Main Exams</button></section> : <section className="practice-setup-card">
      <div className="practice-card-heading"><div className="practice-icon-tile"><i className="bi bi-shield-check" /></div><div><h2>{exam?.exam_name || exam?.name || "Beginner Main Exam"}</h2><p>{exam?.exam_duration_minutes || exam?.duration_minutes || 60} minutes · Official examination</p></div></div>
      <ol className="beginner-exam-rules">{RULES.map((rule, i) => <li key={i}>{rule}</li>)}</ol>
      <label className="beginner-exam-accept"><input type="checkbox" checked={checked} onChange={(e) => setChecked(e.target.checked)} /> I have read and agree to follow the examination rules.</label>
      {error && <p role="alert">{error}</p>}
      <button type="button" disabled={!checked || starting} onClick={start}>{starting ? "Preparing exam…" : "Continue to Examination"}</button>
      <button type="button" className="secondary" onClick={() => navigate("/beginner/main-exam")}>Cancel</button>
    </section>}
  </main></div></div>;
}
